import * as Yup from 'yup';
import { formFieldModelCreate } from './ausenciaEmpleadoFormModel';

const {
    formField: {
        empleado_id,
        absence_type,
        start_date,
        end_date,
        description,
        approval_status
    }
} = formFieldModelCreate;

export const validationSchemaCreate = [
    Yup.object().shape({
        [empleado_id.name]: Yup.object().nullable().required(empleado_id.errorMsg),
        [absence_type.name]: Yup.object().nullable().required(absence_type.errorMsg),
        [start_date.name]: Yup.string().required(start_date.errorMsg).test(
            'min-date',
            'La fecha inicial no puede ser menor a la actual',
            function (value) {
                if (!value) return true;
                const todayStr = new Date().toISOString().split('T')[0];
                return value >= todayStr;
            }
        ),
        [end_date.name]: Yup.string().required(end_date.errorMsg).test(
            'greater-than-start',
            'La fecha final debe ser mayor a la inicial',
            function (value) {
                if (!value) return true;
                const startDateValue = this.parent[start_date.name];
                if (!startDateValue) return true;
                return value > startDateValue;
            }
        ),
        [description.name]: Yup.string().required(description.errorMsg),
        [approval_status.name]: Yup.object().nullable().required(approval_status.errorMsg)
    })
];
